// File: client/src/variants/party/index.js
// Party Chess as a platform plugin.

import rulebook from './rulebook';
import { usePartyRuntime } from './usePartyRuntime';

const partyVariant = {
  id: 'party',
  name: 'Party Chess',
  tagline: 'Every few turns, pick a fun modifier from three. Chess, but a party.',
  icon: '🎉',
  accent: 'from-pink-500 to-fuchsia-700',
  supportedGameTypes: ['ai', 'local'],
  order: 7,
  rulebook,
  useRuntime: usePartyRuntime,
};

export default partyVariant;
